import React from 'react';
export const ResponsiveImage = ({ image, title, className }) => {
  // taking a base file name
  // let image = 'https://cdn.shopify.com/s/files/1/1425/9574/products/One-Of-…ind-Mexico-The-Perfect-Bag-Medium-No.-36242.jpg?v=1590081513';
  if (!image) {
    return null;
  }

  // we start by splitting the file into its components
  let firstSplit = image.split('?v=');
  let baseName = firstSplit[0].slice(0, -4);
  let extension = firstSplit[0].slice(-4);

  // which ultimately allows us to inject a file size to use in responsive images
  // console.log(`${baseName}_600x${extension}`);
  return (
    <img
      src={`${baseName}_200x${extension}`}
      srcSet={`
        ${baseName}_200x${extension} 200w,
        ${baseName}_400x${extension} 400w,
        ${baseName}_600x${extension} 600w,
        ${baseName}_1200x${extension} 1200w,
        ${baseName}_1900x${extension} 1900w
      `}
      width={image.width}
      height={image.height}
      alt={title}
      loading="lazy"
      className={className ? className : ''}
    ></img>
  );
};
